import { connect } from 'react-redux';
import { initialize, destroy } from 'redux-form';
import applyDiscount from '%evp_ticket_frontend/js/redux/currentCart/actions/applyDiscount';
import DiscountBlock from './component/DiscountBlock';
import { FORM_NAME } from './component/DiscountBlock/config/constants';
import initialData from './component/DiscountBlock/config/skeleton';
import { selectDiscountsEnabled } from '%evp_ticket_frontend/js/redux/currentEvent/selectors';

export default connect(
    state => ({
        discountsEnabled: selectDiscountsEnabled(state),
    }),
    dispatch => ({
        applyDiscount: payload => dispatch(applyDiscount(payload)),
        initializeForm: () => dispatch(initialize(FORM_NAME, initialData)),
        destroyForm: () => dispatch(destroy(FORM_NAME)),
    }),
)(DiscountBlock);
